import { createApp } from "vue";
import App from "./App.vue";

import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import "./index.css";
import "vuetify/dist/vuetify.min.css";
import router from "./router";
import store from "@/store/vuex";
import { initAuthInterceptors } from "@/auth";

loadFonts();

// Auth interceptor'ları başlat — her API isteğine otomatik token ekler,
// 401 yanıtlarında otomatik logout yapar
initAuthInterceptors(router, store);

const app = createApp(App);
app.use(store);
app.use(router);
app.use(vuetify);
app.mount("#app");
